import { SelectOption } from '@navstation-portal/shared/data-model/common';

export const VesselTypes = {
  PCTC: 'pctc',
  PRODUCT_TANKER: 'product_tanker',
  SHUTTLE_TANKER: 'shuttle_tanker',
  RO_RO: 'ro_ro',
  PCC: 'pcc',
  BULK_CARRIER: 'bulk_carrier',
  VLCC: 'tanker',
  DRIL_SHIP: 'drillship',
  SUPPLY_VESSEL: 'supply_vessel',
  TUG: 'tug',
  CHEMICAL_TANKER: 'chemical_tanker',
  GAS_CARRIER: 'gas_carrier',
  COMBINATION_CARRIER: 'combination_carrier',
  VEHICLE_CARRIER: 'vehicle_carrier',
  REEFER: 'reefer',
  GENERAL_CARGO: 'general_cargo',
  CONTAINER_SHIP: 'container_ship',
  RO_PAX: 'ro_pax',
  LNG_CARRIER: 'lng_carrier',
  TANKER: 'tanker',
  REFRIGERATED_CARGO: 'refrigerated_cargo',
  RO_RO_PASSENGER: 'ro_pax',
  RO_RO_HIGH_SPEED: 'ro_ro_passenger_high_speed',
  CRUISE_PASSENGER: 'cruise_passenger',
} as const;

export type VesselType = (typeof VesselTypes)[keyof typeof VesselTypes];

export const VESSEL_TYPES: SelectOption[] = [
  { code: VesselTypes.TANKER, name: 'Tanker' },
  { code: VesselTypes.PRODUCT_TANKER, name: 'Product Tanker' },
  { code: VesselTypes.CHEMICAL_TANKER, name: 'Chemical Tanker' },
  { code: VesselTypes.SHUTTLE_TANKER, name: 'Shuttle Tanker' },
  { code: VesselTypes.GAS_CARRIER, name: 'Gas Carrier' },
  { code: VesselTypes.BULK_CARRIER, name: 'Bulk Carrier' },
  { code: VesselTypes.COMBINATION_CARRIER, name: 'Combination Carrier' },
  { code: VesselTypes.VEHICLE_CARRIER, name: 'Vehicle Carrier' },
  { code: VesselTypes.REEFER, name: 'Reefer' },
  { code: VesselTypes.GENERAL_CARGO, name: 'General Cargo' },
  { code: VesselTypes.RO_RO, name: 'Ro-Ro Ship' },
  { code: VesselTypes.REFRIGERATED_CARGO, name: 'Refrigerated Cargo Ship' },
  { code: 'container_ro_ro', name: 'Container / Ro-Ro' },
  { code: VesselTypes.CONTAINER_SHIP, name: 'Container Ship' },
  { code: VesselTypes.RO_PAX, name: 'Ro-Pax for Freight' },
  { code: VesselTypes.RO_PAX, name: 'Ro-Ro for Passenger' },
  {
    code: VesselTypes.RO_RO_HIGH_SPEED,
    name: 'Ro-Ro for Passenger - High Speed',
  },
  { code: VesselTypes.LNG_CARRIER, name: 'LNG Carrier' },
  { code: VesselTypes.PCTC, name: 'Pure Car, Truck Carrier' },
  { code: VesselTypes.PCC, name: 'Pure Car Carrier' },
  { code: VesselTypes.TANKER, name: 'Large Crude Carrier' },
  { code: VesselTypes.DRIL_SHIP, name: 'Drill Ship' },
  { code: VesselTypes.SUPPLY_VESSEL, name: 'Supply Vessel' },
  { code: VesselTypes.TUG, name: 'Tug Vessel' },
  { code: VesselTypes.CRUISE_PASSENGER, name: 'Cruise Passenger' },
];
